<template>
  <v-app>
    <v-layout>
      <AppHeader @toggle-drawer="drawer = !drawer" />
      <SidebarMenu v-model="drawer" :turnos-only="authStore.isTurnosOnly" />
      <!-- Main Content -->
      <v-main>
        <router-view v-slot="{ Component }">
          <div id="main-app">
            <component :is="Component" :title="getTitleForRoute($route.path)" />
          </div>
        </router-view>
      </v-main>
    </v-layout>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { OPCIONES_MENU } from '@/utils/opcionesMenu'
import SidebarMenu from './SidebarMenu.vue'
import AppHeader from './AppHeader.vue'
import { useAuthStore } from '@/stores/authStore'
import { useRoute } from 'vue-router'

const authStore = useAuthStore()
// const router = useRouter()
const route = useRoute()
const drawer = ref(false)

// Verificar si el usuario es de solo turnos y redirigir si es necesario
onMounted(() => {
  window.addEventListener('toggle-drawer', toggleDrawer)
  if (authStore.isTurnosOnly && route.path !== '/turnos/ver-turnos') {
    console.log('AuthenticatedLayout detectó usuario de solo turnos')
    window.location.href = '/turnos/ver-turnos'
  }
})
onUnmounted(() => {
  window.removeEventListener('toggle-drawer', toggleDrawer)
})

function toggleDrawer() {
  drawer.value = !drawer.value
}
const getTitleForRoute = (routePath) => {
  // Si es usuario de solo turnos, siempre devolver "Ver Turnos"
  if (authStore.isTurnosOnly) {
    return 'Ver Turnos'
  }

  const menuEntries = Object.entries(OPCIONES_MENU)
  for (const entry of menuEntries) {
    const submenu = entry[1]
    const item = submenu.items.find((item) => item.route === routePath)
    if (item) {
      return item.text
    }
  }
  return ''
}
</script>

<style scoped>
#main-app {
  max-width: 98% !important;
  margin-left: auto;
  margin-right: auto;
  /* padding: 16px; */
  min-height: calc(100vh - 100px);
}

.v-main {
  height: 100%;
}
</style>
